import React from 'react';
import PropTypes from 'prop-types';
import Glyph from '../Glyph/Glyph';
import './LabeledRadio.scss';

const LabeledRadio = (props) => {
    return(
        <div className= "labeled-radio">
                <input 
                    checked= {props.checked}
                    id= {props.id}
                    name= {props.name}
                    type= "radio"
                    value= {props.value}
                    onClick= {props.onClick}
                    onChange= {props.onChange}/>
                <label 
                    htmlFor= {props.id}>
                    <Glyph 
                        glyph={props.glyph}/>
                    {props.label}
                </label>
            </div>
    );
};

LabeledRadio.propTypes = {
    checked: PropTypes.bool,
    glyph: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    value: PropTypes.string
};

export default LabeledRadio;





// WEBPACK FOOTER //
// ./src/components/base/LabeledRadio/LabeledRadio.js